import _request from 'superagent'
import superagentDefaults from 'superagent-defaults'
import { localStrings } from '@/utils/localization'
import { getUserInfoFromLocalStorage } from '@/utils/auth'

const superagent = superagentDefaults()
const requestType = {
  init: getUserInfoFromLocalStorage()
    ? () =>
        superagent
          .set('Accept-Language', localStrings.getLanguage())
          .withCredentials()
    : () => superagent.set('Accept-Language', localStrings.getLanguage()),
  delete: url => requestType.init().delete(url),
  get: url => requestType.init().get(url),
  post: url => requestType.init().post(url),
  put: url => requestType.init().put(url)
}

const defaultRequest = (method, url) => {
  return requestType[method.toLowerCase()](url)
}

export const request = (method, url) => {
  if (getUserInfoFromLocalStorage()) {
    return _request(method, url)
      .set('Accept-Language', localStrings.getLanguage())
      .withCredentials()
  } else {
    return _request(method, url).set(
      'Accept-Language',
      localStrings.getLanguage()
    )
  }
}

export default defaultRequest



// WEBPACK FOOTER //
// ./src/utils/superagent.js